<template>
    <CustomSelectOne v-if="loaded" :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
        item-label="label" item-value="value" :label="label" :required="required"
        :noPlaceholder="noPlaceholder"/>
</template>

<script>
import CustomSelectOne from "./inner/CustomSelectOne";
import {getDocumentTypes} from "@/swagger/vue-api-client";

export default {
    name: "CustomSelectOneDocumentType",
    components: {CustomSelectOne},

    props: {
        name: {
            type: String,
        },
        label: {
            type: String,
        },
        emptyValue: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        modelValue: null,
        noPlaceholder: {
            type: Boolean,
            default: false,
        },
    },

    emits: ["update:modelValue"],

    computed: {
        internalValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },

    data() {
        return {
            items: [],
            loaded: false,
        };
    },

    beforeMount() {
        getDocumentTypes().then((response) => {
            this.items = response.data;
            this.loaded = true;
        });
    },
};
</script>

<style scoped>
</style>
